var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignupTermChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_6327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21674 14.9994C8.10247 14.9991 7.98951 14.9752 7.88486 14.9293C7.7802 14.8835 7.6861 14.8166 7.6084 14.7328L3.5584 10.4244C3.40701 10.2631 3.32591 10.0482 3.33294 9.82709C3.33997 9.60595 3.43456 9.39666 3.5959 9.24527C3.75724 9.09388 3.97212 9.01277 4.19325 9.01981C4.41439 9.02684 4.62368 9.12143 4.77507 9.28277L8.20841 12.9411L15.2167 5.27444C15.2879 5.18587 15.3763 5.11278 15.4767 5.05966C15.5771 5.00653 15.6873 4.97449 15.8006 4.9655C15.9138 4.95652 16.0277 4.97077 16.1352 5.0074C16.2427 5.04402 16.3416 5.10224 16.4258 5.17848C16.51 5.25471 16.5777 5.34736 16.6248 5.45072C16.6719 5.55409 16.6974 5.66599 16.6997 5.77955C16.7019 5.89312 16.681 6.00595 16.638 6.11111C16.5951 6.21628 16.5312 6.31156 16.4501 6.3911L8.83341 14.7244C8.75644 14.8097 8.66267 14.8782 8.55798 14.9255C8.45329 14.9728 8.33995 14.998 8.22507 14.9994H8.21674Z",
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_6327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignupTermChecked);
export default __webpack_public_path__ + "static/media/icon_signup_termChecked.78f734b379a89e6ca9073ffb5f0a0303.svg";
export { ForwardRef as ReactComponent };